// import SayfaDetay from "./Modules/Sayfalar/SayfaDetay";
import SayfaList from "./Modules/Sayfalar/SayfaList";

export default {
  namespaced: true,
  modules: {
    // SayfaDetay,
    SayfaList,
  },
};
